/**
 * @fileoverview gRPC-Web generated client stub for accountpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: accountpb/subaccount.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.accountpb = require('./subaccount_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.SubAccountServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.SubAccountServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.SubAccount,
 *   !proto.accountpb.CreateSubAccountResponse>}
 */
const methodDescriptor_SubAccountService_CreateSubAccount = new grpc.web.MethodDescriptor(
  '/accountpb.SubAccountService/CreateSubAccount',
  grpc.web.MethodType.UNARY,
  proto.accountpb.SubAccount,
  proto.accountpb.CreateSubAccountResponse,
  /**
   * @param {!proto.accountpb.SubAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.CreateSubAccountResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.SubAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.CreateSubAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.CreateSubAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.SubAccountServiceClient.prototype.createSubAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.SubAccountService/CreateSubAccount',
      request,
      metadata || {},
      methodDescriptor_SubAccountService_CreateSubAccount,
      callback);
};


/**
 * @param {!proto.accountpb.SubAccount} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.CreateSubAccountResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.SubAccountServicePromiseClient.prototype.createSubAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.SubAccountService/CreateSubAccount',
      request,
      metadata || {},
      methodDescriptor_SubAccountService_CreateSubAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.SubAccount,
 *   !proto.accountpb.UpdateSubAccountResponse>}
 */
const methodDescriptor_SubAccountService_UpdateSubAccount = new grpc.web.MethodDescriptor(
  '/accountpb.SubAccountService/UpdateSubAccount',
  grpc.web.MethodType.UNARY,
  proto.accountpb.SubAccount,
  proto.accountpb.UpdateSubAccountResponse,
  /**
   * @param {!proto.accountpb.SubAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.UpdateSubAccountResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.SubAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.UpdateSubAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.UpdateSubAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.SubAccountServiceClient.prototype.updateSubAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.SubAccountService/UpdateSubAccount',
      request,
      metadata || {},
      methodDescriptor_SubAccountService_UpdateSubAccount,
      callback);
};


/**
 * @param {!proto.accountpb.SubAccount} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.UpdateSubAccountResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.SubAccountServicePromiseClient.prototype.updateSubAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.SubAccountService/UpdateSubAccount',
      request,
      metadata || {},
      methodDescriptor_SubAccountService_UpdateSubAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ReadSubAccountRequest,
 *   !proto.accountpb.ReadSubAccountResponse>}
 */
const methodDescriptor_SubAccountService_ReadSubAccount = new grpc.web.MethodDescriptor(
  '/accountpb.SubAccountService/ReadSubAccount',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ReadSubAccountRequest,
  proto.accountpb.ReadSubAccountResponse,
  /**
   * @param {!proto.accountpb.ReadSubAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadSubAccountResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ReadSubAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.ReadSubAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ReadSubAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.SubAccountServiceClient.prototype.readSubAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.SubAccountService/ReadSubAccount',
      request,
      metadata || {},
      methodDescriptor_SubAccountService_ReadSubAccount,
      callback);
};


/**
 * @param {!proto.accountpb.ReadSubAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ReadSubAccountResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.SubAccountServicePromiseClient.prototype.readSubAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.SubAccountService/ReadSubAccount',
      request,
      metadata || {},
      methodDescriptor_SubAccountService_ReadSubAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.DeleteSubAccountRequest,
 *   !proto.accountpb.DeleteSubAccountResponse>}
 */
const methodDescriptor_SubAccountService_DeleteSubAccount = new grpc.web.MethodDescriptor(
  '/accountpb.SubAccountService/DeleteSubAccount',
  grpc.web.MethodType.UNARY,
  proto.accountpb.DeleteSubAccountRequest,
  proto.accountpb.DeleteSubAccountResponse,
  /**
   * @param {!proto.accountpb.DeleteSubAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.DeleteSubAccountResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.DeleteSubAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.DeleteSubAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.DeleteSubAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.SubAccountServiceClient.prototype.deleteSubAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.SubAccountService/DeleteSubAccount',
      request,
      metadata || {},
      methodDescriptor_SubAccountService_DeleteSubAccount,
      callback);
};


/**
 * @param {!proto.accountpb.DeleteSubAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.DeleteSubAccountResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.SubAccountServicePromiseClient.prototype.deleteSubAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.SubAccountService/DeleteSubAccount',
      request,
      metadata || {},
      methodDescriptor_SubAccountService_DeleteSubAccount);
};


module.exports = proto.accountpb;

